import { render, staticRenderFns } from "./prev_terms_conditions.vue?vue&type=template&id=24c7e966"
import script from "./prev_terms_conditions.vue?vue&type=script&lang=js"
export * from "./prev_terms_conditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports